import { render, staticRenderFns } from "./AboutTechWhatBlock.vue?vue&type=template&id=fbc9f46e"
import script from "./AboutTechWhatBlock.vue?vue&type=script&lang=js"
export * from "./AboutTechWhatBlock.vue?vue&type=script&lang=js"
import style0 from "./AboutTechWhatBlock.vue?vue&type=style&index=0&id=fbc9f46e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports